import React from "react";
import ReactDOM from "react-dom";
import { navigate } from "@reach/router";
import { AuthProvider } from "react-use-auth";

import App from "./App";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <AuthProvider
      navigate={navigate}
      auth0_domain="dev-s86rnuxa.auth0.com"
      auth0_client_id="7i1vDrmeQNftvNXQGivZ46BxrPi2XWuk"
    >
      <App />
    </AuthProvider>
  </React.StrictMode>,
  rootElement
);
